import React from 'react';
import { Button, Form, Segment, Input } from 'semantic-ui-react';
import axios from 'axios';
import 'react-widgets/dist/css/react-widgets.css';
import 'react-datepicker/dist/react-datepicker.css';

axios.defaults.xsrfHeaderName = "X-XSRF-TOKEN";
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
//axios.defaults.crossDomain = true;


export default class PremiseFilter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            organizationalUnitId: null,
            roomName: null,
            roomCode: null,
            roomType: null,
            floor: null,
            area: null,
            seatCapacity: null,
            examSeatCapacity: null,
            disabledAccess: null,
            property: null,
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.onFilterData = this.onFilterData.bind(this);
    }

    onFilterData() {
        const premiseFilterData = {
            organizationalUnit: this.state.organizationalUnitId,
            name: this.state.roomName,
            roomType: this.state.roomType,
            code: this.state.roomCode,
            area: this.state.area,
            disabledAccess: this.state.disabledAccess,
            property: this.state.property,
            floor: this.state.floor,
            seatCapacity: this.state.seatCapacity,
            examSeatCapacity: this.state.examSeatCapacity,
        };

        this.props.onFilterData(premiseFilterData);
    }


    handleInputChange(event, { name, value }) {
        this.setState({
            [name]: value
        });
    }

    handleDateChange(name, date) {
        this.setState({
            [name]: date
        });
    }


    render() {
        return (
            <Segment raised>
                <Form>
                    {this.props.organizationalUnitPrivilege &&
                    <Form.Group widths="3">
                        <Form.Dropdown clearable
                            label="Organizaciona jedinica"
                            placeholder="Organizaciona jedinica"
                            value={this.state.organizationalUnitId}
                            onChange={this.handleInputChange}
                            name="organizationalUnitId"
                            options={this.props.organizationalUnits}
                            search
                            fluid
                            selection
                        />
                    </Form.Group>
                    }
                    <Form.Group widths="equal">
                        <Form.Field
                            control={Input}
                            label="Naziv prostorije"
                            name="roomName"
                            value={this.state.roomName}
                            onChange={this.handleInputChange}
                            placeholder="Unesite naziv prostorije"
                        />

                        <Form.Field
                            control={Input}
                            label="Kod prostorije"
                            name="roomCode"
                            value={this.state.roomCode}
                            onChange={this.handleInputChange}
                            placeholder="Unesite naziv prostorije"
                        />

                        <Form.Dropdown clearable
                            label="Tip prostorije"
                            placeholder="Izaberite tip"
                            value={this.state.roomType}
                            options={this.props.roomTypes}
                            onChange={this.handleInputChange}
                            name="roomType"
                            search
                            fluid
                            selection
                        />
                    </Form.Group>

                    <Form.Group widths="equal">
                        <Form.Field
                            label="Sprat"
                            type="number"
                            control={Input}
                            name="floor"
                            value={this.state.floor}
                            onChange={this.handleInputChange}
                            placeholder="Unesite sprat"
                        />
                        <Form.Field
                            label="Površina (m²)"
                            type="number"
                            control={Input}
                            name="area"
                            value={this.state.area}
                            onChange={this.handleInputChange}
                            placeholder="Unesite površinu"
                        />

                        <Form.Dropdown clearable
                            label="Imovina"
                            placeholder="Izaberite imovinu"
                            value={this.state.property}
                            options={this.props.properties}
                            onChange={this.handleInputChange}
                            name="property"
                            search
                            fluid
                            selection
                        />
                    </Form.Group>

                    <Form.Group widths="equal">
                        <Form.Field
                            label="Broj mjesta"
                            type="number"
                            control={Input}
                            name="seatCapacity"
                            value={this.state.seatCapacity}
                            onChange={this.handleInputChange}
                            placeholder="Unesite broj mjesta"
                        />
                        <Form.Field
                            label="Broj mjesta za ispit"
                            type="number"
                            control={Input}
                            name="examSeatCapacity"
                            value={this.state.examSeatCapacity}
                            onChange={this.handleInputChange}
                            placeholder="Unesite broj mjesta za ispit"
                        />
                        <Form.Dropdown clearable
                            label="Pristup invalidima"
                            value={this.state.disabledAccess}
                            onChange={this.handleInputChange}
                            options={this.props.disabledAccesses}
                            name="disabledAccess"
                            placeholder="Izaberite pristup invalidima"
                            search
                            fluid
                            selection
                        />
                    </Form.Group>
                    <Button
                        color="blue"
                        onClick={() => this.onFilterData()}
                    >
                    Filtriraj
                    </Button>
                    <Button
                        basic
                        color="blue"
                        onClick={this.props.cancelFilter}
                    >
                        Odustani
                    </Button>
                </Form>
            </Segment>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Assets/Premises/PremisesFilter.js